import React, { useState, useEffect } from 'react';

import { APIROOT } from '../../../Helpers/configs';

import { HighlightOff } from '@mui/icons-material';

import { Grid, Typography, Autocomplete, TextField } from '@mui/material';
import { ticketTypoTitle, ticketTypoInfo } from '../../shared/commonStyle';

import { filterMethod } from '../../../Helpers/helpers';

import { INSTALL_TICKETTYPES } from '../../shared/CONSTANTS';
// import ClearIcon from '@mui/icons-material/Clear';
// import IconButton from '@mui/material';

import { fieldTransform } from '../../shared/commonStyle';
const INSTALL_TICKETTYPESLIST = [...INSTALL_TICKETTYPES];

const InstallTicketType = (props) => {
  const ticketTypeData = props.ticketTypeData;
  const ticketStatus = props.ticketStatus;
  const onTicketTypeDataChange = props.onTicketTypeDataChange;

  const [selectedTicketType, setSelectedTicketType] = useState(
    ticketTypeData.ticketType
  );

  const [selectedTech, setSelectedTech] = useState(ticketTypeData.techAssigned);
  const [selectedAssistTech, setSelectedAssistTech] = useState(
    ticketTypeData.assistantTech
  );
  const [subbieAssigned, setSubbieAssigned] = useState(
    ticketTypeData.subbieAssigned
  );
  const [subbieContactNr, setSubbieContactNr] = useState(
    ticketTypeData.subbieContactNr
  );
  const [purchaseOrder, setPurchaseOrder] = useState(
    ticketTypeData.purchaseOrder
  );

  const [usersList, setUsersList] = useState([]);

  // HANDLE CHANGES

  const handleChange = (event) => {
    const eventTarget = event.target;
    switch (eventTarget.id) {
      case 'subbieContactNr':
        onTicketTypeDataChange('subbieContactNr', eventTarget.value);
        setSubbieContactNr(eventTarget.value);

        break;
      case 'purchaseOrder':
        onTicketTypeDataChange('purchaseOrder', eventTarget.value);
        setPurchaseOrder(eventTarget.value);

        break;
      default:
        break;
    }
  };

  const handleListChange = (event, newValue) => {
    let eventTarget;
    let eventValue;

    if (event.target.id === 'clearTech') {
      eventTarget = 'techAssigned';
      eventValue = { name: null, id: null };
    } else if (event.target.id === 'clearAssist') {
      eventTarget = 'assistantTech';
      eventValue = { name: null, id: null };
    } else if (event.target.id === 'clearSub') {
      eventTarget = 'subbieAssigned';
      eventValue = { name: null, id: null };
    } else {
      eventTarget = event.target.parentNode.id.split('-').shift();
      eventValue = newValue;
    }

    onTicketTypeDataChange(eventTarget, eventValue);
    setAutocompleteValue(eventTarget, eventValue);
  };

  const setAutocompleteValue = (event, newValue) => {
    switch (event) {
      case 'ticketType':
        setSelectedTicketType({ id: newValue.id, name: newValue.name });
        break;
      case 'techAssigned':
        setSelectedTech({ id: newValue.id, name: newValue.name });
        break;
      case 'assistantTech':
        setSelectedAssistTech({ id: newValue.id, name: newValue.name });
        break;
      case 'subbieAssigned':
        setSubbieAssigned({ id: newValue.id, name: newValue.name });
        break;
      default:
        break;
    }
  };

  // GET TECH SUB LIST
  useEffect(() => {
    activeTech('%').then((data) => {
      setUsersList(data.data.value);
      // mapAvailableCabinetTypes(data.data.value);
    });
  }, []);

  // const handleClearClick = () => {
  //   console.log('clear');
  // };

  return (
    <Grid
      container
      // justifyContent='space-between'
      // alignItems='center'
      flexDirection={{ xs: 'column', sm: 'row' }}
      sx={{ fontSize: '12px' }}
      xs={12}
      md={12}
      lg={12}
      spacing={0}
      rowGap={1}
    >
      <Grid
        container
        xs={12}
        md={6}
        flexDirection='row'
        rowGap={1}
        columnGap={1}
        alignContent='flex-start'
      >
        <Grid item xs={12} lg={4}>
          <Typography style={ticketTypoTitle}>Ticket Type:</Typography>
        </Grid>
        <Grid item xs={12} lg={6} sx={{ textTransform: 'capitalize' }}>
          <Autocomplete
            disabled={ticketStatus !== 'new' ? true : false}
            sx={{
              width: '100%',
              background: '#ffffff',
              padding: 0,
              ...fieldTransform,
            }}
            name='ticketType'
            key='ticketType'
            id='ticketType'
            variant='standard'
            size='small'
            value={selectedTicketType}
            onChange={handleListChange}
            disablePortal
            options={INSTALL_TICKETTYPESLIST}
            filterOptions={filterMethod}
            getOptionLabel={(option) => option.name || ''}
            renderInput={(params) => <TextField {...params} />}
            isOptionEqualToValue={(option, value) => {
              return option.name === value.name ? true : false;
            }}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <Typography style={ticketTypoTitle}>Tech Assigned:</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <Autocomplete
            disabled={
              ticketStatus === 'new' ||
              ticketStatus === 'logged' ||
              ticketStatus === 'assigned'
                ? false
                : true
            }
            clearIcon={
              <HighlightOff
                id='clearTech'
                // onClick={
                //   // setSelectedTech([]);
                //   // onTicketTypeDataChange('techAssigned', {});
                //   // (event) => handleListChange(event, {})
                //   (event) => {
                //     return event;
                //   }
                // }
              />
            }
            // disabled={selectedTicketType.name === 'repair' ? false : true}
            sx={{
              width: '100%',
              background: '#ffffff',
              padding: 0,
            }}
            name='techAssigned'
            key='techAssigned'
            id='techAssigned'
            variant='standard'
            size='small'
            value={selectedTech}
            onChange={handleListChange}
            disablePortal
            options={usersList.filter((item) => item.type === 'technician')}
            filterOptions={filterMethod}
            getOptionLabel={(option) => option.name || ''}
            renderInput={(params) => <TextField {...params} id='techInput' />}
            isOptionEqualToValue={(option, value) => {
              return option.id === value.id ? true : false;
            }}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <Typography style={ticketTypoTitle}>Assistant Tech:</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <Autocomplete
            disabled={
              ticketStatus === 'new' ||
              ticketStatus === 'logged' ||
              ticketStatus === 'assigned'
                ? false
                : true
            }
            clearIcon={
              <HighlightOff
                id='clearAssist'
                // onClick={
                //   // setSelectedTech([]);
                //   // onTicketTypeDataChange('techAssigned', {});
                //   // (event) => handleListChange(event, {})
                //   (event) => {
                //     return event;
                //   }
                // }
              />
            }
            // disabled={selectedTicketType.name === 'repair' ? false : true}
            sx={{
              width: '100%',
              background: '#ffffff',
              padding: 0,
            }}
            name='assistantTech'
            key='assistantTech'
            id='assistantTech'
            variant='standard'
            size='small'
            value={selectedAssistTech}
            onChange={handleListChange}
            disablePortal
            options={usersList.filter((item) => item.type === 'technician')}
            filterOptions={filterMethod}
            getOptionLabel={(option) => option.name || ''}
            renderInput={(params) => <TextField {...params} />}
            isOptionEqualToValue={(option, value) => {
              return option.id === value.id ? true : false;
            }}
          />
        </Grid>
      </Grid>
      <Grid
        container
        xs={12}
        md={6}
        flexDirection='row'
        rowGap={1}
        columnGap={1}
        alignContent='flex-start'
      >
        <Grid item xs={12} lg={5}>
          <Typography style={ticketTypoTitle}>
            Subcontractor Assigned:
          </Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <Autocomplete
            disabled={
              ticketStatus === 'new' ||
              ticketStatus === 'logged' ||
              ticketStatus === 'assigned'
                ? false
                : true
            }
            clearIcon={
              <HighlightOff
                id='clearSub'
                // onClick={
                //   // setSelectedTech([]);
                //   // onTicketTypeDataChange('techAssigned', {});
                //   // (event) => handleListChange(event, {})
                //   (event) => {
                //     return event;
                //   }
                // }
              />
            }
            // disabled={selectedTicketType.name === 'repair' ? true : false}
            sx={{
              width: '100%',
              background: '#ffffff',
              padding: 0,
            }}
            name='subbieAssigned'
            key='subbieAssigned'
            id='subbieAssigned'
            variant='standard'
            size='small'
            value={subbieAssigned}
            onChange={handleListChange}
            disablePortal
            options={usersList.filter((item) => item.type === 'subbie')}
            filterOptions={filterMethod}
            getOptionLabel={(option) => option.name || ''}
            renderInput={(params) => (
              <TextField
                {...params}
                // inputProps={{
                //   endAdornment: (
                //     <HighlightOff onClick={(event) => console.log(event)} />
                //   ),
                // }}
              />
            )}
            isOptionEqualToValue={(option, value) => {
              return option.id === value.id ? true : false;
            }}
          />
        </Grid>

        <Grid item xs={12} lg={5}>
          <Typography style={ticketTypoTitle}>
            Subcontractor Contact Nr.:
          </Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            // disabled={selectedTicketType.name === 'repair' ? true : false}
            disabled={
              ticketStatus === 'new' ||
              ticketStatus === 'logged' ||
              ticketStatus === 'assigned'
                ? false
                : true
            }
            size='small'
            sx={{
              width: '100%',
              background: '#ffffff',
              padding: 0,
            }}
            required
            id='subbieContactNr'
            defaultValue={subbieContactNr}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} lg={5}>
          <Typography style={ticketTypoTitle}>Purchase Order:</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            // disabled={selectedTicketType.name === 'repair' ? true : false}
            size='small'
            sx={{
              width: '100%',
              background: '#ffffff',
              padding: 0,
            }}
            id='purchaseOrder'
            defaultValue={purchaseOrder}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default InstallTicketType;

async function activeTech(type) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };

  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  let body = {
    pagereq: {
      filter: {
        fullfilter: [
          {
            field: 'active',
            search: '1',
            strict: true,
          },
          {
            field: 'type',
            search: type,
            strict: true,
          },
        ],
      },
    },
  };

  const request = new Request(`${APIROOT}/api/usersv2`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });

  const response = await fetch(request);

  const data = response.json();
  return data;
}
